// import 'theme/moydom/less/pages/auth.less';
import $ from 'jquery';
import Cleave from 'cleave.js';

export class PhoneInput {
    init($element) {
        this.phone = new Cleave($element, {
            numericOnly: true,
            prefix: '(',
            noImmediatePrefix: true,
            delimiters: [') ', '-', '-'],
            blocks: [4, 3, 2, 2],
        });
    }
}

$(() => {
    $('.js-phone').each((_, element) => {
        new PhoneInput().init($(element));
    });
});
